import { gql } from '@apollo/client';

export default gql`
  mutation processFreeUpgrade($bookingReference: String!, $currency: Currency!, $segments: [ExchangeInputSegment]!) {
    processFreeUpgrade(bookingReference: $bookingReference, currency: $currency, segments: $segments) {
      additionalDetails {
        key
        value
        itemRef
      }
      isPackage
      hotels {
        itemRef
      }
      outbound {
        serviceType {
          code
        }
        products {
          ...product
        }
      }
      inbound {
        serviceType {
          code
        }
        products {
          ...product
        }
      }
      productFamily
      productFamilyGroup
      payments {
        ...PaymentFragment
        createdBy
        externalReference
      }
      extraOnlyParentBookingReference
      totalPriceToBePaid
    }
  }

  fragment PaymentFragment on Payment {
    refId
    reference
    provider
    availableRefundAmount
    method
  }

  fragment passenger on Passenger {
    id
    type
    firstName
    lastName
    email
    phoneNumber
    birthDate
    loyaltyNumber
  }
  fragment product on Product {
    uuid
    itemRef
    price
    tariffDetails {
      tariffCode
    }
    code
    inventoryClass
    name
    cancelled
    provisional
    canBeRebooked
    canBeCancelled
    canBeRefunded
    afterSalesRules {
      active
      validUntil
      price
      type
      currentActive
    }
    passenger {
      ...passenger
    }
  }
`;
